import Moment from 'moment'

export default {
  methods: {
    capitalize: function (data) {
      if (!data) return ''
      data = data.toString()
      return data.charAt(0).toUpperCase() + data.slice(1)
    },

    phone (data) {
      let cleaned = ('' + data).replace(/\D/g, '')
      let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3]
      }
      return null
    },

    address (data) {
      let formattedAddress = data
      return formattedAddress
    },

    time (date) {
      if (date === null || !date) {
        return ''
      }
      return Moment(date).format('hh:mmA')
    },

    timeAgo (date) {
      if (date === null || !date) {
        return ''
      }
      return Moment(date).fromNow()
    },

    date (date) {
      if (date === null || !date) {
        return ''
      }
      // return Moment(date).format('MMM Do YYYY')
      return Moment(date).format('MMM-DD-YYYY')
    },

    dateUtc (date) {
      if (date === null || !date) {
        return ''
      }
      return Moment.utc(date).format('MMM-DD-YYYY')
    },

    dateFromUtc (date) {
      if (date === null || !date) {
        return ''
      }
      return Moment.utc(date).local().format('MMM-DD-YYYY')
    },

    datetime (date) {
      if (date === null || !date) {
        return ''
      }
      return Moment(date).format('MMM-DD-YYYY hh:mmA')
    },

    dateTimeAgo (date) {
      if (date === null || !date) {
        return ''
      }
      return `${Moment(date).format('MM/DD/YYYY')} (${Moment(date).fromNow()})`
    },

    money (amount) {
      if (!amount) {
        return '$0.00'
      }
      if (amount < 0) {
        return '$(' + Number(Math.abs(amount)).toFixed(2) + ')'
      } else {
        return '$' + Number(amount).toFixed(2)
      }
    },

    moneyNoSign (amount) {
      if (!amount) {
        return '0.00'
      }
      if (amount < 0) {
        return '(' + Number(Math.abs(amount)).toFixed(2) + ')'
      } else {
        return Number(amount).toFixed(2)
      }
    },

    yesOrNo (value) {
      return value ? 'Yes' : 'No'
    },

    expiration (value) {
      if (!value) {
        return ''
      }

      return value.slice(-2) + '/' + value.slice(0, 2)
    },

    resizeTable () {
      let table = document.getElementsByTagName('table')[0]
      table.style.display = 'none'
      // eslint-disable-next-line no-unused-expressions
      table.offsetHeight
      table.style.display = ''
    },

    focusRef (ref) {
      this.$nextTick(() => {
        if (this.$refs[ref]) {
          this.$refs[ref].focus()
        }
      })
    },

    objectPretty (data) {
      try {
        if (data && data !== null) {
          if (typeof data === 'string' && data.length) {
            return JSON.stringify(JSON.parse(data), null, 2)
          } else if (typeof data === 'object' && Object.keys(data).length) {
            return JSON.stringify(data, null, 2)
          } else {
            return '{}'
          }
        }
      } catch (error) {}

      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/display.js